export const UPDATE = "@map/UPDATE";
export const SET_MODE = "@map/SET_MODE";



// WEBPACK FOOTER //
// ./src/app/map/constants.js